import '/assets/styles/pages/smf/faq.scss';
// import { useEffect, useState } from 'react';

// Partials
import Collapser from '/views/partials/collapser';
import { useTranslation } from '/utilities/i18n';

// Data
import faqs from '/data/smf-faqs';

const normalizeTranslationKey = (text) => text.replace(/\s*\n\s*/g, ' ').trim();

const SMFIfPay = () => {
	const { t } = useTranslation();

	return (
		<div className="wrapper">
			<ul className="faq-list">
				{faqs.map((faq, nth) => (
					<li className="list-item" key={nth}>
						<Collapser
							wysiwyg
							className="item-dropdown"
							html={t(normalizeTranslationKey(faq.description))}
							title={t(faq.title)}
						/>
					</li>
				))}
			</ul>
		</div>
	);
};

export default SMFIfPay;
